export default __webpack_public_path__ + "static/richmond-logo-c9354adac652ac22ddbc23eb05c242c9.png";